import React, { FC } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'recompose';

import { SearchSortDirections, SearchSortFields } from 'api';
import * as paths from 'paths';
import { Layouts, ProfileList } from 'components';
import { withFollowed, IWithFollowed } from 'providers';

import { FilterSelect, QueryList } from '../components';

interface IMatchParams {
  department_id: string;
  location_id: string;
}

interface IPropsEnhanced extends IWithFollowed, RouteComponentProps<IMatchParams> {}

const RESULTS_FROM = 0;
const SIZE = 12;

const enhancers = compose<IPropsEnhanced, {}>(withFollowed('users'), withRouter);

const PeopleIndex: FC<IPropsEnhanced> = props => {
  const { match, users } = props;

  const isIndex = match.path === paths.people;
  const isFollowing = match.path === paths.peopleFollowing;
  const isEveryone = match.path === paths.peopleEveryone;
  const isDepartmentFilter = match.path === paths.peopleDepartment;
  const isLocationFilter = match.path === paths.peopleLocation;

  const filterVariables = {
    results_from: RESULTS_FROM,
    size: SIZE,
  };

  let main = null;

  if (isIndex) {
    const variables = { ...filterVariables, auto_exclude: true };
    main = <QueryList emptyStateName="peopleRecommended" variables={variables} />;
  }

  if (isFollowing) {
    main = <ProfileList emptyStateName="peopleFollowing" disableLoadMore profiles={users} />;
  }

  if (isEveryone) {
    const variables = {
      ...filterVariables,
      auto_exclude: false,
      sort: SearchSortFields.Title,
      sort_direction: SearchSortDirections.Asc,
    };
    main = <QueryList variables={variables} />;
  }

  if (isDepartmentFilter) {
    const { department_id } = match.params;
    const variables = { ...filterVariables, required_department_id: department_id };

    main = <QueryList emptyStateName="peopleDepartments" variables={variables} />;
  }

  if (isLocationFilter) {
    const { location_id } = match.params;
    const variables = { ...filterVariables, required_location_id: location_id };

    main = <QueryList emptyStateName="peopleLocations" variables={variables} />;
  }

  return (
    <Layouts.App2Column sidebar={<FilterSelect />} main={<Layouts.AppMain1Column main={main} />} />
  );
};

export default enhancers(PeopleIndex);
